import Layout from '../../components/feature/Layout';
import CapacitacionCultura from '../home/components/CapacitacionCultura';
import SEO from '../../components/feature/SEO';

const capacitacionJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Capacitación en Seguridad HSE',
  provider: {
    '@type': 'Organization',
    name: 'SafeLine Solutions',
    url: `${import.meta.env.VITE_SITE_URL ?? ''}`,
  },
  url: `${import.meta.env.VITE_SITE_URL ?? ''}/capacitacion`,
  description: 'Programas de capacitación preventiva y cultura de seguridad para tu equipo. Cursos HSE especializados en trabajo en altura, primeros auxilios, manejo defensivo y más.',
  areaServed: {
    '@type': 'Place',
    name: 'Latinoamérica',
  },
  serviceType: 'Capacitación Preventiva y Cultura de Seguridad',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Cursos de Capacitación HSE',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'Trabajo en Altura' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'Primeros Auxilios' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'Manejo Defensivo' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'Prevención de Riesgos' } },
    ],
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: `${import.meta.env.VITE_SITE_URL ?? ''}/` },
      { '@type': 'ListItem', position: 2, name: 'Servicios', item: `${import.meta.env.VITE_SITE_URL ?? ''}/servicios` },
      { '@type': 'ListItem', position: 3, name: 'Capacitación', item: `${import.meta.env.VITE_SITE_URL ?? ''}/capacitacion` },
    ],
  },
};

export default function CapacitacionPage() {
  return (
    <Layout>
      <SEO
        title="Capacitación Preventiva HSE | Cultura de Seguridad | SafeLine Solutions"
        description="Programas de capacitación preventiva y cultura de seguridad HSE para tu equipo. Cursos especializados en trabajo en altura, primeros auxilios, manejo defensivo y prevención de riesgos en Latinoamérica."
        keywords="capacitación HSE, cursos seguridad laboral, trabajo en altura, primeros auxilios, prevención riesgos, cultura de seguridad"
        canonical="/capacitacion"
        jsonLd={capacitacionJsonLd}
      />
      <div className="pt-20">
        <CapacitacionCultura />
      </div>
    </Layout>
  );
}
